import React, { useState, useEffect } from 'react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 max-w-sm">
      <div className="bg-[#0a0a0a] text-white p-6 rounded-2xl shadow-2xl">
        <p className="text-sm text-gray-300 mb-4">
          Our website uses cookies to enhance user experience. By clicking "Accept", you consent to our use of cookies.{' '}
          <a href="#" className="underline hover:text-white">Privacy policy</a>.
        </p>
        <div className="flex gap-3">
          <button
            onClick={handleAccept}
            className="px-4 py-2 border border-white rounded-full text-sm font-medium hover:bg-white hover:text-black transition-colors duration-300"
          >
            Accept
          </button>
          <button
            onClick={handleReject}
            className="px-4 py-2 border border-gray-600 rounded-full text-sm font-medium text-gray-400 hover:border-white hover:text-white transition-colors duration-300"
          >
            Reject
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
